import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import styles from './pageloader.module.scss'
import { cn } from '@/lib/utils'


export default function PageLoader() {
  const [ isLoading, setLoading ] = useState(false)
  const router = useRouter()

  useEffect(() => {
    const start = () => setLoading(true)
    const stop = () => setLoading(false)

    router.events.on('routeChangeStart', start)
    router.events.on('routeChangeComplete', stop)
    return () => {
      router.events.off('routeChangeStart', start)
      router.events.off('routeChangeComplete', stop)
    }
  }, [ router ])

  return (
    <div className={cn('relative h-0.5 w-full overflow-hidden transition-all', !isLoading && 'invisible opacity-0')}>
      <div className={`h-0.5 bg-gradient-to-r from-indigo-300 via-purple-600 to-pink ${styles.loader}`} />
    </div>
  )
}
